import { Container } from './Announcement.styled';

const Announcement = () => {
  return <Container>50-70% Off Sitewide Including New Arrivals! "exclusions apply</Container>;
};

export default Announcement;